/* global System */
// register component(s) with react habitat

export default {
  DownloadEl: () => System.import('./Component'),
}
